import smoothscroll from 'smoothscroll-polyfill'

// Polyfill para añadir scroll behavior
smoothscroll.polyfill()
